/* ==== band-b.js ==== */
/* ============================================================
   BAND B — the range: live catalog painting.

   Prices ship baked into the markup (correct at build time), so
   with this file blocked the section still shows real numbers.
   On the theme the porter appends #hx-catalog-live, rendered by
   Liquid from all_products; merging it over the static block
   means price, compare-at and availability follow admin and can
   never drift from the register.
   ============================================================ */
(() => {
'use strict';

/* ---------- live catalog ---------- */
const read = (id) => {
  const el = document.getElementById(id);
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch { return null; }
};

const cat = read('hx-catalog');
if (!cat) return;
const live = read('hx-catalog-live');
if (live && live.models) {
  for (const k of Object.keys(live.models)) {
    /* An unresolvable handle renders as {} — the static numbers stay. */
    if (live.models[k] && live.models[k].price) Object.assign(cat.models[k] = cat.models[k] || {}, live.models[k]);
  }
}

const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
let cheapest = Infinity;

for (const [k, m] of Object.entries(cat.models)) {
  if (!m || !m.price) continue;
  /* Accessories (the ionizer filters) never set the "from ₹X a day" pill. */
  if (!m.accessory) cheapest = Math.min(cheapest, m.price);
  document.querySelectorAll(`[data-price-of="${k}"]`).forEach((el) => { el.textContent = inr.format(m.price); });
  document.querySelectorAll(`[data-compare-of="${k}"]`).forEach((el) => {
    /* No compare-at, or one at/below price: hide the strike rather than
       contradicting the price beside it. */
    if (m.compare && m.compare > m.price) { el.hidden = false; el.textContent = inr.format(m.compare); }
    else el.hidden = true;
  });
  document.querySelectorAll(`[data-perday-of="${k}"]`).forEach((el) => {
    el.textContent = inr.format(Math.ceil(m.price / 365));
  });
}

if (isFinite(cheapest)) {
  document.querySelectorAll('[data-perday-min]').forEach((el) => {
    el.textContent = inr.format(Math.ceil(cheapest / 365));
  });
}

})();

/* ==== band-c.js ==== */
/* BAND C — no behaviour yet. The tech and belief sections are static. */

/* ==== band-d.js ==== */
/* ============================================================
   BAND D — checkout accelerator hook for the mini cart.

   The home page sells nothing directly (every CTA is a link to a
   PDP or collection), but the nav mini cart can hold items added
   elsewhere, and its Checkout button must behave like the rest of
   the store: GoKwik one-page checkout by default, Razorpay Magic
   behind ?magic=1, native /checkout as the always-working
   fallback. Flags, entry points and fallback contract are copied
   from hydromax-A/band-d.js — see the annotations there. The
   layout renders gk-merchant-lite, so window.gokwikSdk and
   window.merchantInfo are present exactly as on hm/hu/hx.
   ============================================================ */
(() => {
'use strict';

const MAGIC_DEFAULT = false;
const GOKWIK_DEFAULT = true;

const q = new URLSearchParams(location.search);

const mFlag = q.get('magic');
let magicOn = MAGIC_DEFAULT;
try {
  if (mFlag === '1') localStorage.setItem('adivaa:magic', '1');
  else if (mFlag === '0') localStorage.removeItem('adivaa:magic');
  magicOn = MAGIC_DEFAULT || localStorage.getItem('adivaa:magic') === '1';
} catch (e) { magicOn = MAGIC_DEFAULT || mFlag === '1'; }
if (mFlag === '0') magicOn = false;

const gkFlag = q.get('gokwik');
let gokwikOn = GOKWIK_DEFAULT;
try {
  if (gkFlag === '1') localStorage.setItem('adivaa:gokwik', '1');
  else if (gkFlag === '0') localStorage.removeItem('adivaa:gokwik');
  gokwikOn = GOKWIK_DEFAULT || localStorage.getItem('adivaa:gokwik') === '1';
} catch (e) { gokwikOn = GOKWIK_DEFAULT || gkFlag === '1'; }
if (gkFlag === '0') gokwikOn = false;

function goMagic() {
  if (typeof window.openRzpLogin !== 'function') return false;
  try { window.openRzpLogin(); return true; } catch (e) { return false; }
}

function goKwik() {
  try {
    if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function' &&
        window.merchantInfo && window.merchantInfo.mid) {
      window.gokwikSdk.initCheckout(window.merchantInfo);
      return true;
    }
    if (typeof window.initiateLogin === 'function') {
      window.initiateLogin();
      return true;
    }
  } catch (e) { /* fall through to native */ }
  return false;
}

const accelOn = () => gokwikOn || magicOn;
const goAccel = () => (gokwikOn ? goKwik() : goMagic());

document.addEventListener('click', (e) => {
  if (!accelOn()) return;
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  if (!e.target.closest('.cartd__checkout')) return;
  /* Only swallow the native anchor if the accelerator actually opened. */
  if (goAccel()) e.preventDefault();
});

/* The drawer ships with Shopify's boilerplate "Shipping and taxes are
   calculated at checkout", which contradicts the store twice over: shipping
   is free across India and prices are MRP, taxes included. */
const note = document.querySelector('.cartd__note');
if (note) note.textContent = 'Free shipping across India. Price includes all taxes.';

/* ChQMe stands down at the footer, like the WhatsApp rail (band-a.js). The
   button loads late on its own schedule, so watch for it patiently. */
const foot = document.querySelector('.foot');
if (foot && 'IntersectionObserver' in window) {
  let atFoot = false;
  const dress = () => {
    const b = document.getElementById('chqme-widget-btn');
    if (b) b.classList.toggle('home-at-foot', atFoot);
    return !!b;
  };
  new IntersectionObserver(([e]) => { atFoot = e.isIntersecting; dress(); }, { threshold: 0 }).observe(foot);
  let tries = 0;
  const t = setInterval(() => { if (dress() || ++tries > 40) clearInterval(t); }, 500);
}

})();
